exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body.about-page{background-color:#fff !important}\n", ""]);
